// extracted by mini-css-extract-plugin
module.exports = {"component":"Account_component__8Y2Zz","account":"Account_account__VGbQk","label":"Account_label__R01yf","name":"Account_name__xSSTC","icon":"Account_icon__zlLiO"};